export const quickMenus = [
  "Pilihan Lokal",
  "Produk Resmi",
  "Pulsa, Tagihan dan Tiket",
  "Flash Sale",
  "Gratis Ongkir",
  "Semua Promo",
];

export const formatRupiah = (value) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export const getProductImage = (barang, index = 0) =>
  barang?.barangfotos?.[index]?.linkGambar ||
  barang?.barangfotos?.[0]?.linkGambar ||
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='640' height='640' viewBox='0 0 640 640'%3E%3Crect width='640' height='640' fill='%23fff1eb'/%3E%3Ccircle cx='320' cy='270' r='92' fill='%23ee4d2d' opacity='.18'/%3E%3Cpath d='M210 410h220l-35-100-48 58-44-86-58 128Z' fill='%23ee4d2d' opacity='.45'/%3E%3Ctext x='320' y='505' text-anchor='middle' font-family='Arial' font-size='28' font-weight='700' fill='%23d93f1f'%3EAJS Ecommerce%3C/text%3E%3C/svg%3E";

export const getFinalPrice = (barang) => {
  const hargaJual = Number(barang?.hargaJual || 0);
  const hargaPromo = Number(barang?.hargaPromo || 0);

  if (hargaPromo > 0 && hargaPromo < hargaJual) {
    return hargaPromo;
  }

  return hargaJual;
};

export const getDiscount = (barang) => {
  const hargaJual = Number(barang?.hargaJual || 0);
  const hargaPromo = Number(barang?.hargaPromo || 0);

  if (!hargaJual || !hargaPromo || hargaPromo >= hargaJual) {
    return 0;
  }

  return Math.round(((hargaJual - hargaPromo) / hargaJual) * 100);
};

export const getSoldPercent = (barang) => {
  const sold = Number(barang?.kuantitasTerjual || 0);
  return Math.max(18, Math.min(96, sold));
};

export const getVisitorId = () => {
  const existingVisitorId = localStorage.getItem("ajs_visitor_id");

  if (existingVisitorId) {
    return existingVisitorId;
  }

  const newVisitorId = `VISITOR-${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 10)}`;
  localStorage.setItem("ajs_visitor_id", newVisitorId);
  return newVisitorId;
};
